"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConvertChurnedDialog = void 0;

var _traceIdIcons = _interopRequireDefault(require("../../assets/img/trace-id-icons.png"));

var _familyIcons = _interopRequireDefault(require("../../assets/img/family-icons.png"));

var _react = _interopRequireWildcard(require("react"));

var _teamIcons = _interopRequireDefault(require("../../assets/img/team-icons.png"));

require("./ConvertChurnedDialog.css");

var _ = require("../../");

var _RenewPlanCard = require("./RenewPlanCard");

var _helpers = require("../../util/helpers");

var _Session = require("../../modules/Session");

var _Tracker = require("../../util/Tracker");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// Convert Churned Dialog
var ConvertChurnedDialog = function ConvertChurnedDialog(_ref) {
  var user = _ref.user,
      step = _ref.step,
      open = _ref.open,
      onClose = _ref.onClose,
      teamName = _ref.teamName,
      isLoading = _ref.isLoading,
      recommendedPlan = _ref.recommendedPlan,
      onPurchasePlan = _ref.onPurchasePlan,
      onLoginSuccess = _ref.onLoginSuccess,
      onButtonClick = _ref.onButtonClick,
      hideCloseButton = _ref.hideCloseButton,
      minimalStyling = _ref.minimalStyling,
      collapseByDefault = _ref.collapseByDefault;

  var _useState = (0, _react.useState)("Family"),
      _useState2 = _slicedToArray(_useState, 2),
      selectedPlan = _useState2[0],
      setSelectedPlan = _useState2[1];

  var _useState3 = (0, _react.useState)("Unlock your video"),
      _useState4 = _slicedToArray(_useState3, 2),
      title = _useState4[0],
      setTitle = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      fired = _useState6[0],
      setFired = _useState6[1];

  var handleDidSelectPlan = function handleDidSelectPlan(plan) {
    var newPlan = plan;

    if (selectedPlan === plan) {
      newPlan = null;
    }

    setSelectedPlan(newPlan);
  };

  var handleDidSelectPurchasePlan = function handleDidSelectPurchasePlan(planTitle, productPricePair) {
    if (typeof onPurchasePlan === "function") {
      onPurchasePlan(productPricePair);
    }
  };

  var handleLoginSuccess = function handleLoginSuccess() {
    if (typeof onLoginSuccess === "function") {
      onLoginSuccess();
    }
  };

  var handleButtonClick = function handleButtonClick(step) {
    if (typeof onButtonClick === "function") {
      onButtonClick(step);
    }
  };

  var isMobile = (0, _helpers.isMobileScreen)();

  var stepRef = function stepRef(element, aStep) {
    if (element && step === aStep && !fired) {
      setFired(true);
      (0, _Tracker.trackEvent)({
        action: 'Step',
        element: element
      });
    }
  };

  (0, _react.useEffect)(function () {
    if (isLoading) {
      setTitle("Loading...");
    } else {
      switch (step) {
        case "login":
          {
            setTitle("Sign in to Trace");
            break;
          }

        case "redirect_to_moments":
          {
            setTitle("Go to your moments");
            break;
          }

        case "redirect_to_traceid":
          {
            setTitle("Go to your Trace iD");
            break;
          }

        case "upgrade":
          {
            setTitle("Unlock your moments");
            break;
          }
      }
    }
  }, [step, isLoading]);
  var firstName = user ? user.first_name : '';
  var lastName = user ? user.last_name : '';
  var minimalStylingCn = minimalStyling ? 'minimal-styling' : '';
  var forceExpand = isMobile ? !collapseByDefault : true;
  return /*#__PURE__*/_react.default.createElement(_.Modal, {
    className: "ConvertChurnedModal ".concat(minimalStylingCn),
    trkContext: "Convert Churned Dialog",
    open: open,
    onShadeClick: function onShadeClick() {
      if (typeof onClose === "function") {
        onClose();
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_.Row, {
    className: "prompt-container",
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement(_.Icon, {
    size: "22",
    type: _.Icon.Type.Lock,
    color: _.Color.White2
  }), /*#__PURE__*/_react.default.createElement(_.Label, {
    bold: true,
    center: true,
    marginLeft: "2",
    className: "prompt-team-name",
    color: _.Color.White2
  }, teamName), /*#__PURE__*/_react.default.createElement(_.Label, {
    bold: true,
    center: true,
    marginLeft: "1",
    className: "prompt",
    color: _.Color.White2
  }, "stopped Tracing")), /*#__PURE__*/_react.default.createElement(_.TitleSection, {
    hideCloseButton: hideCloseButton,
    onCloseClick: function onCloseClick() {
      if (typeof onClose === "function") {
        onClose();
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_.ModalTitle, {
    content: title
  })), /*#__PURE__*/_react.default.createElement(_.ContentSection, null, teamName && /*#__PURE__*/_react.default.createElement(_.Row, {
    className: "inner-prompt-container",
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement(_.Icon, {
    size: "22",
    type: _.Icon.Type.Lock,
    color: _.Color.Black
  }), /*#__PURE__*/_react.default.createElement(_.Label, {
    bold: true,
    center: true,
    marginLeft: "3",
    className: "prompt",
    color: _.Color.Black
  }, teamName, " ", "stopped Tracing")), !isLoading && step === 'redirect_to_moments' && /*#__PURE__*/_react.default.createElement(_.Column, {
    trkContext: "Redirect to Moments",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    ref: function ref(e) {
      return stepRef(e, 'redirect_to_moments');
    }
  }), /*#__PURE__*/_react.default.createElement(_.Avatar, {
    className: "user-avatar",
    size: 90,
    imageUrl: "https://lapi.traceup.com/tracebot-".concat(process.env.REACT_APP_TRACE_ENV, "/avatars?user=").concat(user === null || user === void 0 ? void 0 : user.user_id),
    initials: (0, _helpers.getInitials)(firstName, lastName)
  }), /*#__PURE__*/_react.default.createElement(_.Label, {
    marginTop: "3",
    marginBottom: "8"
  }, "All your moments are safe in your Trace iD"), /*#__PURE__*/_react.default.createElement(_.Button, {
    primary: true,
    onClick: function onClick(e) {
      return handleButtonClick('redirect_to_moments');
    },
    content: /*#__PURE__*/_react.default.createElement(_.Row, {
      alignItems: "center"
    }, /*#__PURE__*/_react.default.createElement(_.Label, {
      type: _.Label.Type.InnerButton,
      content: "My Moments",
      marginLeft: "2"
    }), /*#__PURE__*/_react.default.createElement(_.Icon, {
      size: 16,
      color: _.Color.TraceShade1,
      type: _.Icon.Type.CheveronRight
    }))
  })), !isLoading && step === 'redirect_to_traceid' && /*#__PURE__*/_react.default.createElement(_.Column, {
    trkContext: "Redirect to TraceiD",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    ref: function ref(e) {
      return stepRef(e, 'redirect_to_traceid');
    }
  }), /*#__PURE__*/_react.default.createElement(_.Avatar, {
    className: "user-avatar",
    size: 90,
    imageUrl: "https://lapi.traceup.com/tracebot-".concat(process.env.REACT_APP_TRACE_ENV, "/avatars?user=").concat(user === null || user === void 0 ? void 0 : user.user_id),
    initials: (0, _helpers.getInitials)(firstName, lastName)
  }), /*#__PURE__*/_react.default.createElement(_.Label, {
    marginTop: "3",
    marginBottom: "8"
  }, "You are not associated with this team."), /*#__PURE__*/_react.default.createElement(_.Button, {
    primary: true,
    onClick: function onClick(e) {
      return handleButtonClick('redirect_to_traceid');
    },
    content: /*#__PURE__*/_react.default.createElement(_.Row, {
      alignItems: "center"
    }, /*#__PURE__*/_react.default.createElement(_.Label, {
      type: _.Label.Type.InnerButton,
      content: "My Trace iD",
      marginLeft: "2"
    }), /*#__PURE__*/_react.default.createElement(_.Icon, {
      size: 16,
      color: _.Color.TraceShade1,
      type: _.Icon.Type.CheveronRight
    }))
  })), !isLoading && step === 'login' && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    ref: function ref(e) {
      return stepRef(e, 'login');
    }
  }), /*#__PURE__*/_react.default.createElement(_Session.LoginForm, {
    width: "300px",
    center: true,
    onSuccess: handleLoginSuccess,
    onFailure: function onFailure(e) {
      return alert('Login failed.');
    }
  })), !isLoading && step === 'upgrade' && /*#__PURE__*/_react.default.createElement(_.Row, {
    trkContext: "Upgrade",
    className: "plan-rows"
  }, /*#__PURE__*/_react.default.createElement("div", {
    ref: function ref(e) {
      return stepRef(e, 'upgrade');
    }
  }), /*#__PURE__*/_react.default.createElement(_RenewPlanCard.RenewPlanCard, {
    title: "iD+",
    selected: selectedPlan === "iD+",
    forceExpand: forceExpand,
    recommended: recommendedPlan === "iD+",
    collapseByDefault: collapseByDefault,
    icon: _traceIdIcons.default,
    subtitleTop: "All your highlights",
    bullets: ["Access to all your past video", "Organize and share highlights with unlimited playlists in Trace iD+", "Upload video from outside Trace"],
    productPricePairs: [{
      name: "traceId",
      product: "traceId_monthly",
      title: "$9.99 monthly"
    }, {
      name: "traceId",
      product: "traceId_yearly",
      title: "$99 yearly"
    }],
    handleDidSelectPlan: handleDidSelectPlan,
    handleDidSelectPurchasePlan: handleDidSelectPurchasePlan
  }), /*#__PURE__*/_react.default.createElement(_RenewPlanCard.RenewPlanCard, {
    title: "Family",
    selected: selectedPlan === "Family",
    recommended: recommendedPlan === "Family",
    forceExpand: forceExpand,
    collapseByDefault: collapseByDefault,
    bullets: ["Access to all your past video", "Trace new games for up to three players", "Share full game video from new games with coaches and other members of the team"],
    subtitleTop: "Highlights + new games for you",
    icon: _familyIcons.default,
    subtitleBottom: "Ships in 30 days",
    productPricePairs: [{
      name: "family",
      product: "family_yearly",
      title: "$2,400 yearly"
    }],
    handleDidSelectPlan: handleDidSelectPlan,
    handleDidSelectPurchasePlan: handleDidSelectPurchasePlan
  }), /*#__PURE__*/_react.default.createElement(_RenewPlanCard.RenewPlanCard, {
    title: "Team",
    selected: selectedPlan === "Team",
    forceExpand: forceExpand,
    collapseByDefault: collapseByDefault,
    recommended: recommendedPlan === "Team",
    icon: _teamIcons.default,
    subtitleTop: "Highlights + new games for your team",
    bullets: ["Access to all your past video", "Trace new games for the whole team", "Automatic editing and personalized playlists for everyone"],
    subtitleBottom: "Ships in 5 days",
    productPricePairs: [{
      name: "team",
      product: "team_yearly",
      title: "$3,800 yearly"
    }],
    handleDidSelectPlan: handleDidSelectPlan,
    handleDidSelectPurchasePlan: handleDidSelectPurchasePlan
  }))));
};

exports.ConvertChurnedDialog = ConvertChurnedDialog;
ConvertChurnedDialog.defaultProps = {
  collapseByDefault: false
};